import React from "react";
import QurealRichEditor from "./QurealRichEditor";

const QurealBasicEditor = (props) => {
    return (
        <QurealRichEditor
            {...props}
            editorOptions={{
                includeTable: true,
                includeMedia: true,
                includeFormatting: true,
                includeAlignment: true,
            }}
            menuFeatures="basic"
            menuType="fixed"
        />
    );
};

export default QurealBasicEditor;
